import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import EventModel from '../../../../../utils/tracking/models';

export const Tab = props => {
  const handleTabClick = () => {
    const clickEvent = new EventModel(
      `BWI list tab-${get(props, 'category', 'no category')}`,
      'listTab',
      'click',
      `Tab-${get(props, 'category', 'no category')}`,
      `${props.tabIndex + 1}`
    );
    clickEvent.triggerTrackingEvent(
      'tab-click',
      clickEvent.getTrackingObject()
    );
  };

  // Start of bwi 2025 custom visuals

  const handleActiveTab = () => {
    if (props?.isMobile) {
      return `url("https://assets.mansueto.com/uploads/mobile_winners_selected.svg")`;
    } else if (props?.isTablet) {
      return `url("https://assets.mansueto.com/uploads/tablet_Winners_selected.svg")`;
    }
    return `url("https://assets.mansueto.com/uploads/active.svg")`;
  };

  const handleInactiveTab = () => {
    if (props?.isMobile) {
      return `url("https://assets.mansueto.com/uploads/mobile_honorrees_deselected.svg")`;
    } else if (props?.isTablet) {
      return `url("https://assets.mansueto.com/uploads/tablet_honorees_deselected.svg")`;
    }
    return `url("https://assets.mansueto.com/uploads/inactive.svg")`;
  };

  const handleFolderTab = () => {
    if (props?.showFolderTabs) {
      if (props.tab === props.tabIndex) {
        return {
          backgroundImage: handleActiveTab(),
          backgroundSize: 'cover',
          width: '100%',
          maxWidth: '580px'
        };
      }
      return {
        backgroundImage: handleInactiveTab(),
        backgroundSize: 'cover',
        width: '100%',
        maxWidth: '580px'
      };
    }
    return {};
  };

  // End of bwi 2025 custom visuals

  return (
    <div
      className={`tab ${props.tab === props.tabIndex ? 'active' : 'inactive'}`}
      onClick={() => {
        props.setTab(props.tabIndex);
        handleTabClick();
      }}
      style={handleFolderTab()}
    >
      {props.category && <div className="category">{props.category}</div>}
      {props.image && <img src={props.image} alt={props.category} />}
    </div>
  );
};

Tab.propTypes = {
  category: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  tab: PropTypes.number.isRequired,
  setTab: PropTypes.func.isRequired,
  tabIndex: PropTypes.number.isRequired
};
